import { api } from '@watchparty/shared';
function toParams(obj) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(obj)) {
        if (value == null || value === '')
            continue;
        if (Array.isArray(value)) {
            for (const v of value)
                params.append(key, String(v));
        }
        else {
            params.set(key, String(value));
        }
    }
    const str = params.toString();
    return str ? `?${str}` : '';
}
export const adminApi = {
    getStats: () => api.get('/admin/stats'),
    browseWorks: (filters, cursor, pageSize = 50) => api.get(`/admin/works${toParams({ ...filters, cursor, pageSize })}`),
    getWorkDetail: (workId) => api.get(`/admin/works/${workId}`),
    setAdultFlag: (workId, isAdult) => api.patch(`/admin/works/${workId}/adult`, { isAdult }),
    getGenres: () => api.get('/admin/genres'),
    browsePeople: (q, cursor, pageSize = 25) => api.get(`/admin/people${toParams({ q, cursor, pageSize })}`),
    getPersonDetail: (personId) => api.get(`/admin/people/${personId}`),
    getLogs: (filters, cursor, pageSize = 50) => api.get(`/admin/logs${toParams({ ...filters, cursor, pageSize })}`),
    getLogDetail: (logId) => api.get(`/admin/logs/${logId}`),
    getToolLogs: (filters, cursor, pageSize = 50) => api.get(`/admin/tool-logs${toParams({ ...filters, cursor, pageSize })}`),
    getToolRuns: (toolName, cursor, pageSize = 25) => api.get(`/admin/tool-logs/runs${toParams({ toolName, cursor, pageSize })}`),
    getToolNames: () => api.get('/admin/tool-logs/tools'),
    getUsersStats: (period) => api.get(`/admin/users/stats${toParams({ period })}`),
    listUsers: (filters, page = 1, pageSize = 50) => api.get(`/admin/users${toParams({ ...filters, page, pageSize })}`),
    getUsersOverview: () => api.get('/admin/users/overview'),
    getUserDetail: (userId) => api.get(`/admin/users/${userId}`),
    getUserMessages: (userId, page = 1, pageSize = 50) => api.get(`/admin/users/${userId}/messages${toParams({ page, pageSize })}`),
    getSettings: () => api.get('/admin/settings'),
    updateSettings: (data) => api.patch('/admin/settings', data),
    getUserLimits: (userId) => api.get(`/admin/users/${userId}/limits`),
    updateUserLimits: (userId, data) => api.patch(`/admin/users/${userId}/limits`, data),
};
